import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function InternationalIcon({ className }: IconProps) {
  return (
    <svg
      width="87"
      height="70"
      viewBox="0 0 87 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1362)">
        <path
          d="M51.7534 0C36.7519 0 23.9652 9.3361 18.8672 22.4689C19.7238 22.3237 20.6013 22.2407 21.4998 22.2407C30.4839 22.2407 37.7548 29.4606 37.7548 38.3817C37.7548 41.5768 36.8146 44.5436 35.2058 47.0332C42.6647 51.2863 47.7209 58.6515 48.8492 67.1784C48.9745 68.0913 48.891 69.0041 48.7238 69.8755C49.7267 69.9585 50.7296 70.0207 51.7534 70.0207C71.226 70.0207 87.0005 54.3568 87.0005 35.0207C87.0005 15.6846 71.226 0 51.7534 0Z"
          fill="#E8ECF7"
        />
        <path
          d="M42.0172 67.2614C41.077 60.083 36.4805 54.0457 30.1498 51.0374C27.5381 52.8008 24.4041 53.8174 20.9985 53.8174C17.5929 53.8174 14.4589 52.7801 11.8681 51.0374C5.5583 54.0664 0.96176 60.083 0.000664312 67.2614C-0.187376 68.7137 0.961759 70 2.44519 70H39.5727C41.0561 70 42.2053 68.7137 42.0172 67.2614Z"
          fill="#00416B"
        />
        <path
          d="M32.4275 37.6557C32.4275 43.9005 27.3295 48.9835 21.0197 48.9835C14.7099 48.9835 9.63281 43.9005 9.63281 37.6557C9.63281 31.4109 14.7308 26.3279 21.0197 26.3279C27.3086 26.3279 32.4275 31.4109 32.4275 37.6557Z"
          fill="#00416B"
        />
        <path
          d="M69.3035 51.141C67.8409 51.6597 64.7069 55.809 66.5037 56.7011C68.4886 57.697 68.9483 56.7634 70.5989 55.2074C72.2703 53.6306 74.1716 54.3567 73.9627 52.8422C73.6493 50.6846 70.766 50.6223 69.3244 51.141"
          fill="#00C4B3"
        />
        <path
          d="M78.5586 12.3028C77.9318 12.9875 77.2632 13.7551 76.5946 14.668C74.9022 16.9709 71.3921 17.0954 69.4699 13.3194C68.7387 11.8672 67.6731 10.7468 66.4613 9.99993C62.5125 7.57255 56.8504 9.10782 54.8237 16.0995C54.761 16.2862 54.7192 16.473 54.6774 16.6597C53.988 19.7925 54.9282 23.3402 60.3187 23.7136C67.3179 24.2116 63.7034 31.141 59.4829 29.6057C55.2416 28.0497 53.1104 26.5145 49.6212 29.2738C46.1112 32.0331 46.7171 36.7427 50.9166 37.4066C53.8835 37.8838 55.4296 42.0539 54.2596 43.3402C52.609 44.7925 50.2689 50.6016 53.3821 54.0248C56.4952 57.4481 58.8561 55.0414 59.7336 53.029C60.6112 51.0165 60.6529 49.6887 62.2408 47.0124C63.4318 45.0207 67.5687 44.1286 67.5687 44.1286C67.5687 44.1286 70.9743 42.9045 68.6133 36.6389C66.2524 30.3734 74.4844 31.4107 76.3021 35.6431C77.8064 39.1701 74.2127 44.9792 80.5852 43.9626C83.1969 43.5477 84.346 44.7095 85.328 45.6638C86.4145 42.3028 86.9995 38.7136 86.9995 34.9792C86.9995 26.307 83.8237 18.3817 78.5586 12.2613"
          fill="#00C4B3"
        />
        <path
          d="M40.1569 10.0001C36.9185 9.21168 35.4559 6.70131 34.8918 4.25317C27.5791 8.21583 21.8543 14.6681 18.8457 22.4482C19.7023 22.303 20.5799 22.22 21.4992 22.22C27.6627 22.22 33.0323 25.6432 35.7902 30.664C36.0618 30.1038 36.2708 29.5021 36.417 28.8382C37.7333 23.1743 30.1281 21.5146 31.6533 17.9669C33.3248 14.0872 46.9055 19.2117 46.9055 13.0913C46.9055 9.73035 42.8731 10.664 40.1569 10.0001Z"
          fill="#00C4B3"
        />
        <path
          d="M43.8975 54.7303C44.2527 51.0996 42.7484 47.22 38.9667 47.4482C36.9609 47.5727 36.1461 46.9502 35.7282 46.1411C35.561 46.4523 35.3521 46.722 35.1641 47.0125C38.6324 48.9834 41.5992 51.5975 43.8766 54.7303H43.8975Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1362">
          <rect width="87" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
